/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable func-style */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { b2x } from '@b2x/react/src';

export interface CivicProps {}

//declare let CookieControl: any;

declare global {
  interface Window {
    CookieControl: any;
  }
}

window.dataLayer = window.dataLayer || [];
function gtag(...args: Array<unknown>) {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export const Civic = (props: CivicProps) => {
  const config = {
    apiKey: 'ec0e4b7e870e2392d07465218c3b2988d9132deb',
    /*
      // https://www.civicuk.com/cookie-control/documentation
    */
    branding: {
      backgroundColor: '#fff',
      buttonIcon: null,
      buttonIconHeight: 50,
      buttonIconWidth: 50,
      fontColor: '#013B5B',
      fontSize: '1em',
      fontSizeHeaders: '1.2em',
      fontSizeIntro: '1.2em',
      fontSizeTitle: '1.2em',
      removeAbout: false,
      removeIcon: false,
      toggleBackground: '#fff',
      toggleColor: '#F0F0F0',
      toggleText: '#013B5B',
    },
    consentCookieExpiry: 360,
    initialState: 'notify',
    layout: 'popup',
    mode: 'gdpr',
    necessaryCookies: ['sessionid', 'csrftoken'],
    optionalCookies: [
      {
        cookies: ['_ga', '_ga*', '_gid', '_gat', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv'],
        description:
          'Questi cookie ci aiutano a migliorare il nostro sito raccogliendo e analizzando informazioni su come il sito viene utilizzato.',
        label: 'Cookie di analitica (Google Analytics)',
        name: 'analytics',

        onAccept: function () {
          gtag('consent', 'update', {
            ad_storage: 'granted',
            analytics_storage: 'granted',
            functionality_storage: 'granted',
            personalization_storage: 'granted',
            security_storage: 'granted',
          });
        },
        onRevoke: function () {
          gtag('consent', 'update', {
            ad_storage: 'denied',
            analytics_storage: 'denied',
            functionality_storage: 'denied',
            personalization_storage: 'denied',
            security_storage: 'denied',
          });
        },
      },
      {
        cookies: [],
        description:
          'Questi cookie ci aiutano a mostrarti messaggi pubblicitari mirati in linea con le tue preferenze manifestate durante la navigazione web e a misurare le campagne pubblicitarie.',
        label: 'Cookies di marketing (Facebook)',
        name: 'marketing',
        onAccept: function () {
          b2x.analytics.initMarketingScripts();
          console.log('Accept marketing cookies');
        },
        onRevoke: function () {
          // Disable Facebook Pixel
          // End Facebook Pixel
        },
        vendors: [
          {
            description: 'Facebook Pixel',
            name: 'Facebook',
            url: 'https://www.facebook.com/policies/cookies/',
          },
        ],
      },
    ],
    position: 'left',
    product: 'PRO',
    text: {
      accept: 'Accetta tutti i cookie',
      acceptSettings: 'Accetta tutti i cookie',
      intro:
        'Utilizziamo cookie tecnici per il funzionamento del sito. In caso di tuo consenso posizioneremo anche cookie di analitica e cookie di marketing. Per impostare le tue preferenze relative ai cookie sposta i cursori su “On” o “Off” e clicca “Salva e chiudi”. Puoi impostare velocemente l’installazione o meno di tutti i cookie di analitica e di marketing tramite i pulsanti “Accetta tutti i cookie” e “Rifiuta tutti i cookie”. Per ulteriori informazioni consulta la nostra Cookie Policy.',
      necessaryDescription:
        'Questi cookie permettono funzionalità essenziali come la gestione del network e la lingua del sito. Puoi disabilitare questi cookie tramite le impostazioni del browser.',
      necessaryTitle: 'Cookie tecnici',
      notifyDescription:
        'Utilizziamo i cookie per ottimizzare la funzionalità del sito e offrirti la migliore esperienza possibile.',
      notifyTitle: 'La tua scelta in merito ai cookie su questo sito',
      reject: 'Rifiuta tutti i cookie',
      rejectSettings: 'Rifiuta tutti i cookie',
      settings: 'Preferenze',
      showVendors: "Mostra i fornitori all'interno di questa categoria",
      thirdPartyDescription: 'Please follow the link(s) below to opt out manually.',
      thirdPartyTitle: 'Warning: Some cookies require your attention',
      title: 'I nostri cookie',
    },
    theme: 'light',
    toggleType: 'slider',
  };

  b2x
    .addScript(
      { id: 'civic', src: 'https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js' },
      { appendToBody: true }
    )
    .then(() => {
      b2x.wait(300).then(() => {
        window.CookieControl && window.CookieControl.load(config);
      });
    });

  return <></>;
};
